/**
 * @file   src\helpers\S3\uploadToS3.js
 * @brief  This file is responsible for upload to S3 functionality
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import { uploadFileToS3 } from "../../services/fileUploadService";
import { IMG_JPEG_FORMAT } from "../../constants/common";

export const uploadToS3 = async (preSignedUrl, file) => {
  const method = "PUT";
  const header = {
    "Content-Type": "multipart/form-data",
  };
  const res = await uploadFileToS3(preSignedUrl, method, file, header);

  if (res) {
    return res;
  } else {
    return null;
  }
};

export const uploadMapImageToS3 = async (preSignedUrl, file) => {
  const response = await fetch(preSignedUrl, {
    method: "PUT",
    body: file,
    headers: {
      "Content-Type": IMG_JPEG_FORMAT, // Change the content type if needed
    },
  });
  if (response.ok) {
    return response.url;
  } else {
    return "";
  }
};

export const uploadVideoToS3 = (preSignedUrl, videoFile, onProgress) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("PUT", preSignedUrl, true);
    xhr.setRequestHeader("Content-Type", videoFile.type);

    // Track upload progress
    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable && onProgress) {
        const progress = Math.round((event.loaded / event.total) * 100);
        onProgress(progress); // Invoke the progress callback
      }
    };

    xhr.onload = () => {
      if (xhr.status === 200) {
        resolve(preSignedUrl.split("?")[0]); // Return the uploaded video's S3 URL
      } else {
        reject(new Error("Failed to upload video to S3"));
      }
    };

    xhr.onerror = () => {
      reject(new Error("Error occurred while uploading video to S3"));
    };

    xhr.send(videoFile);
  });
};
